
















































































import Vue from "vue";
import Component from "vue-class-component";
import { File, FILE_OVERVIEW_QUERY, FileOverviewResult } from "@/models/queries/FileOverviewQuery";
import { graphqlClient } from "@/utils/graphql";
import { Base64Helper } from "@/utils/base64";
import FileOpener from "@/components/core/controls/file-opener.vue";

@Component({
  components: { FileOpener }
})
export default class FileOverview extends Vue {
  private isLoading: boolean = true;
  private loadingCompleted: boolean = false;
  private files: File[] | null = null;
  private restrictedUser: boolean = false;

  public mounted() {
    this.restrictedUser = JSON.parse(sessionStorage.getItem("cedoon_user") || "").restrict_access;
    graphqlClient
      .query<FileOverviewResult>({
        query: FILE_OVERVIEW_QUERY
      })
      .then(result => {
        if (result && result.data && !result.errors) {
          this.isLoading = false;
          this.loadingCompleted = true;
          this.files = result.data.files;
        } else {
          this.isLoading = false;
          this.loadingCompleted = true;
          this.files = null;
        }
      })
      .catch(error => {
        console.error(error);
        this.isLoading = false;
        this.loadingCompleted = true;
        this.files = null;
      });
  }
}
